import { BaseController } from "@app/views/base.view";
import { Utils } from "@tools";
import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { DrawerService } from "@app/services/drawer.service";

declare global {
    interface Window {
        __kbAngularHost?: { injector?: { get(token: string): { [0]: Element } } };
    }
}

export interface IDrawerScope extends ng.IScope {
    drawerService: DrawerService;
}

@NgView({
    token: Token.DrawerView,
    dependencies: [
        Token.$Scope,
        Token.DrawerService,
        Token.$Timeout,
    ]
})
export class DrawerController extends BaseController {

    constructor(
        public $scope: IDrawerScope,
        public drawerService: DrawerService,
        $timeout: ng.ITimeoutService
    ) {

        super();

        $scope.drawerService = drawerService;

        // routine for resizing drawer buttons if there are too many
        let resizeDrawer = Utils.throttle(() => {
            let $drawerButtons = jQuery(".kb-drawer__buttons");
            let totalWidth: number;
            $drawerButtons.find(".kb-drawer__button").each((i, e) => {
                totalWidth += jQuery(e).outerWidth();
            });

            $drawerButtons.toggleClass("is-icons-only", totalWidth > $drawerButtons.innerWidth());
        }, 100);

        $scope.$watchCollection("drawerService.drawers", () => {
            resizeDrawer();
        });

        $scope.$watch("drawerService.visible", (newValue: boolean, oldValue: boolean) => {
            if (newValue != oldValue) {
                // Scope to Angular's bootstrap element only. The global
                // $(".kb-content") selector was also matching Vue's
                // .kb-content when AngularHost is active, mutating its
                // classes via jQuery outside Vue's knowledge. Since Vue
                // doesn't re-render the class after the external mutation,
                // the stale kb-content--no-drawer class persisted after
                // AngularHost unmounted, pushing the drawer off-screen.
                const root = window.__kbAngularHost?.injector?.get('$rootElement')?.[0]
                    ?? document;
                $(root).find(".kb-content").toggleClass("kb-content--no-drawer", !newValue);
            }
        });

        // track the window size
        jQuery(window).resize(() => {
            resizeDrawer();
        });
    }
}
